import { Container, Row, Col } from "react-bootstrap";

import "../css/licences.css";

const Licences = () => {
    return (
        <Container fluid id="licencias">
            <Row>
                <Col md={{ span: 10, offset: 1 }}>
                    <iframe
                        title="Licencias VVHH para FAQ"
                        width="100%"
                        height="1060"
                        src="https://app.powerbi.com/view?r=eyJrIjoiZTUxMDMxNzItOWZkYi00YmNkLTg0M2MtOTE5YmY5YjhiZTU0IiwidCI6ImZmYzVkMWU0LWM4OTYtNGZjNi04ZmM4LTU3NzczNDg5NGZmYyIsImMiOjR9"
                        allowFullScreen
                    ></iframe>
                </Col>
            </Row>
        </Container>
    );
};

export default Licences;
